<nb-card class="detail-dialog">
  <nb-card-header>
    <div class="detail-dialog__head">
      <div>
        <h5>{{ course.fullname || course.shortname || 'Kurs' }}</h5>
        <p class="muted">
          {{ course.shortname || '—' }} · #{{ course.moodle_course_id }}
        </p>
      </div>
      <button nbButton ghost size="small" (click)="ref.close()" aria-label="Schließen">
        <nb-icon icon="close-outline"></nb-icon>
      </button>
    </div>
  </nb-card-header>

  <nb-card-body>
    <div *ngIf="loading" class="detail-dialog__loading">
      <nb-spinner status="basic"></nb-spinner>
    </div>

    <ng-container *ngIf="!loading">
      <!-- Dozent assignment ─────────────────────────────────── -->
      <section class="detail-dialog__section">
        <div class="detail-dialog__section-title">
          {{ 'pages.moodle.detail.dozentAccessHeader' | translate }}
        </div>
        <p class="detail-dialog__section-hint muted">
          {{ 'pages.moodle.detail.dozentAccessHint' | translate }}
        </p>

        <div *ngIf="dozents.length === 0" class="muted">
          {{ 'pages.moodle.detail.noAssignableDozents' | translate }}
        </div>

        <div *ngIf="dozents.length > 0" class="detail-dialog__dozent-row">
          <nb-select
            multiple
            [(ngModel)]="selectedDozentIds"
            [placeholder]="'pages.moodle.detail.dozentPlaceholder' | translate"
            fullWidth
          >
            <nb-option *ngFor="let d of dozents" [value]="d.id">
              {{ d.name || d.email }}
            </nb-option>
          </nb-select>

          <button
            nbButton
            size="small"
            status="primary"
            [disabled]="!dozentDirty || saving"
            (click)="saveDozentAccess()"
          >
            <nb-icon *ngIf="saving" icon="loader-outline"></nb-icon>
            {{ 'pages.moodle.detail.saveAccess' | translate }}
          </button>
        </div>
      </section>

      <!-- Enrolled Moodle users (read-only) ────────────────── -->
      <section class="detail-dialog__section">
        <div *ngIf="enrollments.length === 0" class="detail-dialog__empty">
          {{ 'pages.moodle.detail.noEnrollments' | translate }}
        </div>

        <ng-container *ngIf="enrollments.length > 0">
          <div class="detail-dialog__section-title">
            {{ 'pages.moodle.detail.enrollmentsHeader' | translate:{ count: enrollments.length } }}
          </div>
          <table class="detail-dialog__table">
            <thead>
              <tr>
                <th>{{ 'pages.moodle.col.name' | translate }}</th>
                <th>{{ 'pages.moodle.col.email' | translate }}</th>
                <th>{{ 'pages.moodle.col.role' | translate }}</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let en of pagedEnrollments; trackBy: trackEn">
                <td class="detail-dialog__name">{{ userLabel(en) }}</td>
                <td class="muted">{{ en.email || '—' }}</td>
                <td class="muted">{{ (en.role_shortnames || []).join(', ') || en.role || '—' }}</td>
              </tr>
            </tbody>
          </table>
          <app-pagination
            [totalItems]="enrollmentTotal"
            [itemsPerPage]="enrollmentPageSize"
            [currentPage]="enrollmentPage"
            [pageSizeOptions]="pageSizeOptions"
            (pageChanged)="onEnrollmentPageChange($event)"
            (itemsPerPageChange)="onEnrollmentPageSizeChange($event)"
          ></app-pagination>
        </ng-container>
      </section>
    </ng-container>
  </nb-card-body>
</nb-card>
